import React, { Component } from 'react'
import {
  Accordion,
  Breadcrumb,
  Col,
  Nav,
  NavItem,
  Panel,
  Row,
  Tabs,
  Tab,
} from 'react-bootstrap'

import Accessories from './accessories'
import Agreements from './agreements'
import Backends from './backends'
import Carriers from './carriers'
import Categories from './categories'
import CompanyStates from './companystates'
import Features from './features'
import Hardware from './hardware'
//import Industries from './industries'
import PartnerTypes from './partnertypes'
import PaymentIntervals from './paymentintervals'
import Service from './service'
import ShippingTypes from './shippingtypes'
import Sources from './sources'
import UpdateIntervals from './updateintervals'
import Vendors from './vendors'

export default class SiteOptions extends Component {
  render() {
    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Site Options</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <div className="clearfix"></div>
          <Tabs defaultActiveKey={ 1 } id="site-options-tabs">
            <Tab eventKey={ 1 } title="Options">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
                <Tab.Container defaultActiveKey={ 1 }>
                  <Row className="clearfix">
                      <Nav bsStyle="tabs">
                        <NavItem eventKey={ 1 } style={{ textAlign: 'right' }}>Industries</NavItem>
                        <NavItem eventKey={ 2 } style={{ textAlign: 'right' }}>Company States</NavItem>
                        { /* <NavItem eventKey={ 2 } style={{ textAlign: 'right' }}>Industries</NavItem> */ }
                        <NavItem eventKey={ 3 } style={{ textAlign: 'right' }}>Partner Types</NavItem>
                        <NavItem eventKey={ 4 } style={{ textAlign: 'right' }}>Sources</NavItem>
                        <NavItem eventKey={ 5 } style={{ textAlign: 'right' }}>Vendors</NavItem>

                      </Nav>
                      <Tab.Content animation>
                        <Tab.Pane eventKey={ 1 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Categories />
                        </Tab.Pane>
                        <Tab.Pane eventKey={ 2 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <CompanyStates />
                        </Tab.Pane>
                        { /*
                        <Tab.Pane eventKey={ 2 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Industries />
                        </Tab.Pane>
                        */ }
                        <Tab.Pane eventKey={ 3 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <PartnerTypes />
                        </Tab.Pane>
                        <Tab.Pane eventKey={ 4 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Sources />
                        </Tab.Pane>
                        <Tab.Pane eventKey={ 5 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Vendors />
                        </Tab.Pane>
                      </Tab.Content>
                  </Row>
                </Tab.Container>
              </div>
            </Tab>
            <Tab eventKey={ 2 } title="Invoice Options">
              <div style={
                {
                  marginBottom: '20px',
                  borderLeft: '1px solid #DDD',
                  borderBottom: '1px solid #DDD',
                  borderRight: '1px solid #DDD',
                  padding: '15px',
                  backgroundColor: '#FFF'
                }
              }>
                <Tab.Container defaultActiveKey={ 1 }>
                  <Row className="clearfix">
                      <Nav bsStyle="tabs">
                        { /* <NavItem eventKey={ 1 } style={{ textAlign: 'right' }}>Accessories</NavItem> */ }
                        <NavItem eventKey={ 1 } style={{ textAlign: 'right' }}>Backends</NavItem>
                        <NavItem eventKey={ 2 } style={{ textAlign: 'right' }}>Carriers</NavItem>
                        { /*<NavItem eventKey={ 4 } style={{ textAlign: 'right' }}>Features</NavItem> */ }
                        { /*<NavItem eventKey={ 5 } style={{ textAlign: 'right' }}>Hardware</NavItem> */ }
                        <NavItem eventKey={ 3 } style={{ textAlign: 'right' }}>Payment Intervals</NavItem>
                        { /*<NavItem eventKey={ 7 } style={{ textAlign: 'right' }}>Service</NavItem> */ }
                        <NavItem eventKey={ 4 } style={{ textAlign: 'right' }}>Shipping Types</NavItem>

                      </Nav>
                      <Tab.Content animation>
                        { /*
                          <Tab.Pane eventKey={ 1 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Accessories />
                        </Tab.Pane>
                        */ }
                        <Tab.Pane eventKey={ 1 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Backends />
                        </Tab.Pane>
                        <Tab.Pane eventKey={ 2 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Carriers />
                        </Tab.Pane>
                        { /*
                        <Tab.Pane eventKey={ 4 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Features />
                        </Tab.Pane>
                        <Tab.Pane eventKey={ 5 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Hardware />
                        </Tab.Pane>
                        */ }
                        <Tab.Pane eventKey={ 3 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <PaymentIntervals />
                        </Tab.Pane>
                        { /*
                        <Tab.Pane eventKey={ 7 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <Service />
                        </Tab.Pane>
                        */ }
                        <Tab.Pane eventKey={ 4 } style={{ padding: '10px', border: '1px solid #ddd', borderTop: '0' }}>
                          <ShippingTypes />
                        </Tab.Pane>
                      </Tab.Content>
                  </Row>
                </Tab.Container>
              </div>
              </Tab>
              { /*
              <Tab eventKey={ 4 } title="Agreements">
                <div style={
                  {
                    marginBottom: '20px',
                    borderLeft: '1px solid #DDD',
                    borderBottom: '1px solid #DDD',
                    borderRight: '1px solid #DDD',
                    padding: '15px',
                    backgroundColor: '#FFF'
                  }
                }>
                  <Agreements />
                </div>
              </Tab>
              */ }
          </Tabs>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/siteoptions.js